module.exports = __webpack_public_path__ + "img/car-2.72793845.png";